import { LoadExtract } from "../../domain/use-case/LoadExtract";
import api from "../../services/api";

export class RemoteLoadExtract implements LoadExtract {
  async handle (params: LoadExtract.Params): Promise<LoadExtract.Result> {
    const response = await api.get(`/order/extract/${params.userId}`, {
      params: {
        startDate: params.startDate.toISOString().split(/T/)[0],
        endDate: params.endDate.toISOString().split(/T/)[0],
        catalogId: params.catalogId
      }
    })
    return response.data
  }
}